<template>
  <v-row no-gutters class="tw-w-full">
    <v-col cols="12" lg="12">
      <v-tabs v-model="tab" color="white" background-color="#0D111B" slider-color="#45D0D2">
        <v-tab href="#home" @click="navTo('/')">Home</v-tab>
        <v-tab href="#casino" @click="navTo('casino')">Casino</v-tab>
        <v-tab href="#live" @click="navTo('/live')">Live</v-tab>
        <v-tab href="#e_sport" @click="navTo('/e_sport')">Esports</v-tab>
        <v-menu
          bottom
          left
          class="sports_menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              class="align-self-center"
              v-bind="attrs"
              v-on="on"
            >
              SPORTS
              <v-icon right>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list dark class="">
            <v-list-item
              v-for="item in sports"
              @click="navTo(item.link)"
              :key="item.id"
            >
              {{ item.name }}
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tab href="#fav" @click="navTo('/favorites')">Favorites</v-tab>
        <v-tab href="#mybet" @click="navTo('/bets')">Sportsbook Bets</v-tab>
        <v-tab href="#search" @click="navTo('/search')">Search</v-tab>
        
      </v-tabs>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    tab: null,
    sports: [
    {
        name : "NBA",
        link: "%2F2%2F1669819088232386560%2F1669819088278523904"
      },
      {
        name : "BasketBall",
        link: "%2F2"
      },
      {
        name : "MMA",
        link: "%2F117"
      },{
        name : "Soccer",
        link: "%2F1"
      },
    ],
  }),
  computed: {
    ...mapState("slotegator", ["bt_reader"]),
  },
  mounted() {
    console.log("ROUTEING", this.$route.query["bt-path"]);
    this.setNav();
  },
  methods: {
    navTo(tab) {
      if (tab == "casino") {
        this.$router.push({ path: "/casino" });
        return;
      }
      console.log("TEST THIS",tab)
      this.bt_reader.updateOptions({ url: tab });
    },
    setNav() {
      switch (this.$route.query["bt-path"]) {
        case "/":
        case undefined:
          this.tab = "home";
          break;
        case "%2Flive":
        case "/live":
          this.tab = "live";
          break;
        case "%2Ffavorites":
        case "/favorites":
          this.tab = "fav";
          break;
        case "%2Fbets":
        case "/bets":
          this.tab = "mybet";
          break;
        case "%2Fsearch":
        case "/search":
          this.tab = "search";
          break;
        case "/109":
        case "%2F109":
        case "/e_sport":
        case "/110":
          this.tab = "e_sport";
          break;
        default:
          this.tab = "home";
      }

      if (
        this.$route.query["bt-path"] &&
        (this.$route.query["bt-path"].includes("/300/") ||
          this.$route.query["bt-path"].includes("/300%2F"))
      ) {
        this.tab = "home";
      }
    },
  },
  watch: {
    "$route.query": function () {
      if (this.tab != "live") this.setNav();
    },
  },
};
</script>
<style>
.sports_menu{
  z-index: 10001 !important;
}
</style>
